global.rivets = rivets;

global.rivets.formatters.above = function (val1, val2) {
  return val1 > val2;
};

// Styles
import '../stylesheets/styles.styl';

// Polyfills
import 'intersection-observer';
import 'requestidlecallback';

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';

// Gsap
import { gsap } from 'gsap';
import { CustomEase, DrawSVGPlugin, ScrollToPlugin, MotionPathPlugin } from 'gsap/all';
gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin, CustomEase, MotionPathPlugin);
CustomEase.create('combeau', 'M0,0,C0.25,0.1,0.25,1,1,1');
gsap.defaults({ ease: 'combeau' });

// Main app
import './managers/AppManager';
